Date.prototype.getMicrosoftJsonFormatted = function () {
    return '/Date('+this.valueOf()+(this.getTimezoneOffset() < 0 ? '+' : '-')+(Math.abs(this.getTimezoneOffset())/60*100+"").padStart(4,"0")+')/'
}
